import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "notifications" }
const _hoisted_2 = { class: "notification__content" }
const _hoisted_3 = { class: "notification__icon" }
const _hoisted_4 = ["innerHTML"]

import IconSuccess from "@/assets/icons/icon__check.svg";
import IconWarning from "@/assets/icons/icon__warning.svg";

export default /*#__PURE__*/_defineComponent({
  __name: 'Notifications',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_notifications = _resolveComponent("notifications", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_notifications, { position: "top right" }, {
      body: _withCtx((props) => [
        _createElementVNode("div", {
          class: _normalizeClass(`notification notification--${props.item.type}`)
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (props.item.type === 'success')
                ? (_openBlock(), _createBlock(_unref(IconSuccess), {
                    key: 0,
                    class: "icon icon--green"
                  }))
                : _createCommentVNode("", true),
              (props.item.type === 'error')
                ? (_openBlock(), _createBlock(_unref(IconWarning), {
                    key: 1,
                    class: "icon"
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: "notification__text",
              innerHTML: props.item.text
            }, null, 8, _hoisted_4)
          ])
        ], 2)
      ]),
      _: 1
    })
  ]))
}
}

})